import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Admin from './pages/Admin';
import ClientPortal from './pages/ClientPortal';

// Redirect component to static HTML page
function RedirectTo({ path }) {
  useEffect(() => { window.location.href = path; }, [path]);
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#F7F3EE', fontFamily: 'Instrument Sans, sans-serif', color: '#0F4C5C', fontSize: '1rem' }}>
      Redirecting...
    </div>
  );
}

// Map React paths → static HTML files
const STATIC_PAGES = {
  '/': '/home.html',
  '/about': '/about.html',
  '/blog': '/blog.html',
  '/recipes': '/recipes.html',
  '/shop': '/shop.html',
  '/pricing': '/pricing.html',
  '/legal': '/legal.html',
  '/diet-review': '/diet-review.html',
};

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin panel — stays in React */}
        <Route path="/admin/*" element={<Admin />} />

        {/* Client portal — stays in React */}
        <Route path="/login/*" element={<ClientPortal />} />
        <Route path="/dashboard/*" element={<ClientPortal />} />

        {/* Public pages — redirect to the original static HTML files */}
        {Object.entries(STATIC_PAGES).map(([reactPath, htmlFile]) => (
          <Route key={reactPath} path={reactPath} element={<RedirectTo path={htmlFile} />} />
        ))}
      </Routes>
    </BrowserRouter>
  );
}
